export default "__VITE_ASSET__DcJ80YQV__"